<template>
  <v-card>
    <!-- {{editItem}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Passenger Flight</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editProjectFlightForm" v-model="valid" lazy-validation>
        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-text-field
              outline
              label="Airlines *"
              v-model="editItem.flight_airlines"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>

          <v-flex md6>
            <v-text-field
              outline
              label="Flight No. *"
              v-model="editItem.flight_number"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-text-field
              outline
              label="Departure *"
              v-model="editItem.flight_departure"
              mask="####-##-## ##:##"
              return-masked-value
              required
              :rules="requiredRules"
              :hint="`Departure format: ${getMyDate('YYYY-MM-DD HH:mm')}`"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex md6>
            <v-text-field
              outline
              label="Arrival*"
              v-model="editItem.flight_arrival"
              mask="####-##-## ##:##"
              return-masked-value
              required
              :rules="requiredRules"
              :hint="`Arrival format: ${getMyDate('YYYY-MM-DD HH:mm')}`"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-text-field
              outline
              label="Destinatoin *"
              v-model="editItem.flight_destination"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>

          <v-flex md6>
            <v-text-field
              outline
              label="Remarks"
              v-model="editItem.flight_notes"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
  MYSQL_DATETIME_FORMAT,
} from "../../mdsir/const";
import {
  getTV,
  removeEmptyProps,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "agents", "employers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,

      contractDateMenu: false,
      dobDateMenu: false,
      medicalDateMenu: false,
      mofaDateMenu: false,
      trainingStartDateMenu: false,
      trainingEndDateMenu: false,
      bmetSubmitDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editProjectFlightForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editProjectFlightForm.reset();
    },
    resetValidation() {
      this.$refs.editProjectFlightForm.resetValidation();
    },
    editItemDo() {
      if (this.$refs.editProjectFlightForm.validate()) {
        // console.log(this.getMyDate(MYSQL_DATETIME_FORMAT, this.editItem.flight_departure, "YYYY-MM-DD HH:mm"));
        // return false;

        this.actionButtonClicked = true;
        this.put(
          "/flight_details",
          removeEmptyProps(
            {
              ...this.editItem,
              flight_departure: this.getMyDate(
                MYSQL_DATETIME_FORMAT,
                this.editItem.flight_departure,
                "YYYY-MM-DD HH:mm"
              ),
              flight_arrival: this.getMyDate(
                MYSQL_DATETIME_FORMAT,
                this.editItem.flight_arrival,
                "YYYY-MM-DD HH:mm"
              ),
            },
            [
              "contract_date",
              "dob",
              "visa_issue_date",
              "flight_date",
              "medical_date",
              "mofa_date",
              "training_start_date",
              "training_end_date",
              "bmet_submit_date",
            ]
          )
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
